<div>
    <form class="g-3" name="UserRightForm" (ngSubmit)="Validate(UserRightForm,'UserRightForm')" #UserRightForm="ngForm"
        novalidate>
        <div class="row m-0 align-items-center">
            <div class="col-md-5">
                <label for="ProfileMasterID" class="form-font-label">Profile</label>
                <ng-select name="ProfileMasterID" (change)="clear()" [(ngModel)]="Filter.ProfileMasterID"
                    #ProfileMasterID="ngModel" placeholder="--Select Profile--" required [items]="userProfiles"
                    bindLabel="ProfileName" bindValue="ProfileMasterID">
                    <ng-template ng-option-tmp let-item="item">
                        <span [ngbTooltip]="item.ProfileName" container="body" placement="right">{{ item.ProfileName }}</span>
                    </ng-template>

                </ng-select>

                <div class="invalid-feedback">
                    Please select profile!
                </div>
            </div>
            <div class="col-auto pt-4">
                <button type="submit" class="upload-btn" [disabled]="isDisabled">
                    <i class="bi bi-gear" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Get Rights':'Loading...'}}
                </button>
            </div>
            <div class="col-auto pt-4">
                <button type="button" (click)="ESS_ExcelDump()" class="upload-btn" [disabled]="isDisabled">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Export All Profile':'Loading...'}}
                </button>
            </div>
        </div>
    </form>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            User Rights
        </div>
        <div class="card-body p-1">
            <table datatable class="customeDatatable table table-bordered">
                <thead class="table-light" style="position: sticky;z-index: 100;top: -9px;">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th>Menu</th>
                        <th style="width: 20px;" class="text-center">View
                            <input class="form-check-input" type="checkbox" id="IsViewAll" name="IsViewAll"
                                (click)="CheckAll('View',$event)">
                        </th>
                        <th style="width: 20px;" class="text-center">Add
                            <input class="form-check-input" type="checkbox" id="IsAddAll" name="IsAddAll"
                                (click)="CheckAll('Add',$event)">
                        </th>
                        <th style="width: 20px;" class="text-center">Edit
                            <input class="form-check-input" type="checkbox" id="IsEditAll" name="IsEditAll"
                                (click)="CheckAll('Edit',$event)">
                        </th>
                        <th style="width: 20px;" class="text-center">Delete
                            <input class="form-check-input" type="checkbox" id="IsDeleteAll" name="IsDeleteAll"
                                (click)="CheckAll('Delete',$event)">
                        </th>
                        <th style="width: 20px;" class="text-center">Print
                            <input class="form-check-input" type="checkbox" id="IsPrintAll" name="IsPrintAll"
                                (click)="CheckAll('Print',$event)">
                        </th>
                    </tr>
                </thead>
                <tbody>
                    @for (userRight of userRights; track userRight.ESS_MenuMasterId; let i = $index;) {
                    <tr>
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td [colSpan]="userRight['SubMenus'].length > 0?6:1"
                            [ngStyle]="{'font-weight': userRight['SubMenus'].length > 0?700:400}">
                            {{userRight['MenuLabel']}}</td>
                        <td *ngIf="userRight['SubMenus'].length == 0" style="width: 20px;" class="text-center"><input
                                class="form-check-input" type="checkbox" id="IsView{{i}}" name="IsView{{i}}"
                                (click)="ViewUnCheck(userRight,$event)" [(ngModel)]="userRight['IsView']"></td>
                        <td *ngIf="userRight['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!userRight['AddApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsAdd{{i}}" name="IsAdd{{i}}" (click)="ViewCheck(userRight)"
                                [(ngModel)]="userRight['IsAdd']" [disabled]="!userRight['AddApplicable']"></td>
                        <td *ngIf="userRight['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!userRight['EditApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsEdit{{i}}" name="IsEdit{{i}}" (click)="ViewCheck(userRight)"
                                [(ngModel)]="userRight['IsEdit']" [disabled]="!userRight['EditApplicable']"></td>
                        <td *ngIf="userRight['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!userRight['DeleteApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsDelete{{i}}" name="IsDelete{{i}}" (click)="ViewCheck(userRight)"
                                [(ngModel)]="userRight['IsDelete']" [disabled]="!userRight['DeleteApplicable']"></td>
                        <td *ngIf="userRight['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!userRight['PrintApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsPrint{{i}}" name="IsPrint{{i}}" (click)="ViewCheck(userRight)"
                                [(ngModel)]="userRight['IsPrint']" [disabled]="!userRight['PrintApplicable']"></td>
                    </tr>

                    @for (submenuL1 of userRight['SubMenus']; track submenuL1.ESS_MenuMasterId; let j = $index) {
                    <tr>
                        <th scope="row" style="width: 5px;">{{i+1}}.{{j+1}}</th>
                        <td [colSpan]="submenuL1['SubMenus'].length > 0?6:1"
                            [ngStyle]="{'font-weight': submenuL1['SubMenus'].length > 0?700:400}">
                            {{userRight['MenuLabel']}} <i class="bi bi-chevron-right"></i> {{submenuL1['MenuLabel']}}
                        </td>
                        <td *ngIf="submenuL1['SubMenus'].length == 0" style="width: 20px;" class="text-center"><input
                                class="form-check-input" type="checkbox" id="IsView{{i}}{{j}}" name="IsView{{i}}{{j}}"
                                (click)="ViewUnCheck(submenuL1,$event)" [(ngModel)]="submenuL1['IsView']"></td>
                        <td *ngIf="submenuL1['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL1['AddApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsAdd{{i}}{{j}}" name="IsAdd{{i}}{{j}}"
                                (click)="ViewCheck(submenuL1)" [(ngModel)]="submenuL1['IsAdd']"
                                [disabled]="!submenuL1['AddApplicable']"></td>
                        <td *ngIf="submenuL1['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL1['EditApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsEdit{{i}}{{j}}" name="IsEdit{{i}}{{j}}"
                                (click)="ViewCheck(submenuL1)" [(ngModel)]="submenuL1['IsEdit']"
                                [disabled]="!submenuL1['EditApplicable']"></td>
                        <td *ngIf="submenuL1['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL1['DeleteApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsDelete{{i}}{{j}}" name="IsDelete{{i}}{{j}}"
                                (click)="ViewCheck(submenuL1)" [(ngModel)]="submenuL1['IsDelete']"
                                [disabled]="!submenuL1['DeleteApplicable']"></td>
                        <td *ngIf="submenuL1['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL1['PrintApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsPrint{{i}}{{j}}" name="IsPrint{{i}}{{j}}"
                                (click)="ViewCheck(submenuL1)" [(ngModel)]="submenuL1['IsPrint']"
                                [disabled]="!submenuL1['PrintApplicable']"></td>
                    </tr>

                    @for (submenuL2 of submenuL1['SubMenus']; track submenuL2.ESS_MenuMasterId; let k = $index) {
                    <tr>
                        <th scope="row" style="width: 5px;">{{i+1}}.{{j+1}}.{{k+1}}</th>
                        <td [colSpan]="submenuL2['SubMenus'].length > 0?6:1"
                            [ngStyle]="{'font-weight': submenuL2['SubMenus'].length > 0?700:400}">
                            {{userRight['MenuLabel']}} <i class="bi bi-chevron-right"></i> {{submenuL1['MenuLabel']}} <i
                                class="bi bi-chevron-right"></i> {{submenuL2['MenuLabel']}}</td>
                        <td *ngIf="submenuL2['SubMenus'].length == 0" style="width: 20px;" class="text-center"><input
                                class="form-check-input" type="checkbox" id="IsView{{i}}{{j}}{{k}}"
                                name="IsView{{i}}{{j}}{{k}}" (click)="ViewUnCheck(submenuL2,$event)"
                                [(ngModel)]="submenuL2['IsView']"></td>
                        <td *ngIf="submenuL2['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL2['AddApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsAdd{{i}}{{j}}{{k}}" name="IsAdd{{i}}{{j}}{{k}}"
                                (click)="ViewCheck(submenuL2)" [(ngModel)]="submenuL2['IsAdd']"
                                [disabled]="!submenuL2['AddApplicable']"></td>
                        <td *ngIf="submenuL2['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL2['EditApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsEdit{{i}}{{j}}{{k}}" name="IsEdit{{i}}{{j}}{{k}}"
                                (click)="ViewCheck(submenuL2)" [(ngModel)]="submenuL2['IsEdit']"
                                [disabled]="!submenuL2['EditApplicable']"></td>
                        <td *ngIf="submenuL2['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL2['DeleteApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsDelete{{i}}{{j}}{{k}}" name="IsDelete{{i}}{{j}}{{k}}"
                                (click)="ViewCheck(submenuL2)" [(ngModel)]="submenuL2['IsDelete']"
                                [disabled]="!submenuL2['DeleteApplicable']"></td>
                        <td *ngIf="submenuL2['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL2['PrintApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsPrint{{i}}{{j}}{{k}}" name="IsPrint{{i}}{{j}}{{k}}"
                                (click)="ViewCheck(submenuL2)" [(ngModel)]="submenuL2['IsPrint']"
                                [disabled]="!submenuL2['PrintApplicable']"></td>
                    </tr>
                    @for (submenuL3 of submenuL2['SubMenus']; track submenuL3.ESS_MenuMasterId; let l = $index) {
                    <tr>
                        <th scope="row" style="width: 5px;">{{i+1}}.{{j+1}}.{{k+1}}.{{l+1}}</th>
                        <td [colSpan]="submenuL3['SubMenus'].length > 0?6:1"
                            [ngStyle]="{'font-weight': submenuL3['SubMenus'].length > 0?700:400}">
                            {{userRight['MenuLabel']}} <i class="bi bi-chevron-right"></i> {{submenuL1['MenuLabel']}} <i
                                class="bi bi-chevron-right"></i> {{submenuL2['MenuLabel']}} <i
                                class="bi bi-chevron-right"></i> {{submenuL3['MenuLabel']}}</td>
                        <td *ngIf="submenuL3['SubMenus'].length == 0" style="width: 20px;" class="text-center"><input
                                class="form-check-input" type="checkbox" id="IsView{{i}}{{j}}{{k}}{{l}}"
                                name="IsView{{i}}{{j}}{{k}}{{l}}" (click)="ViewUnCheck(submenuL3,$event)"
                                [(ngModel)]="submenuL3['IsView']"></td>
                        <td *ngIf="submenuL3['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL3['AddApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsAdd{{i}}{{j}}{{k}}{{l}}" name="IsAdd{{i}}{{j}}{{k}}{{l}}"
                                (click)="ViewCheck(submenuL3)" [(ngModel)]="submenuL3['IsAdd']"
                                [disabled]="!submenuL3['AddApplicable']"></td>
                        <td *ngIf="submenuL3['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL3['EditApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsEdit{{i}}{{j}}{{k}}{{l}}" name="IsEdit{{i}}{{j}}{{k}}{{l}}"
                                (click)="ViewCheck(submenuL3)" [(ngModel)]="submenuL3['IsEdit']"
                                [disabled]="!submenuL3['EditApplicable']"></td>
                        <td *ngIf="submenuL3['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL3['DeleteApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsDelete{{i}}{{j}}{{k}}{{l}}" name="IsDelete{{i}}{{j}}{{k}}{{l}}"
                                (click)="ViewCheck(submenuL3)" [(ngModel)]="submenuL3['IsDelete']"
                                [disabled]="!submenuL3['DeleteApplicable']"></td>
                        <td *ngIf="submenuL3['SubMenus'].length == 0" style="width: 20px;" class="text-center"
                            [ngClass]="{'bgDiable':!submenuL3['PrintApplicable']}"><input class="form-check-input"
                                type="checkbox" id="IsPrint{{i}}{{j}}{{k}}{{l}}" name="IsPrint{{i}}{{j}}{{k}}{{l}}"
                                (click)="ViewCheck(submenuL3)" [(ngModel)]="submenuL3['IsPrint']"
                                [disabled]="!submenuL3['PrintApplicable']"></td>
                    </tr>
                    }
                    }
                    }
                    }
                </tbody>
            </table>
        </div>
        <div class="card-footer" *ngIf="userRights.length > 0 && Filter.ProfileMasterID > 0">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" (click)="ESS_ProfileMenuRightsInsertUpdate()" class="btn btn-primary"
                    [disabled]="isDisabled"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>

    </div>
</div>